import { getCurrentInstance } from 'vue'

export function useToast() {
  const instance = getCurrentInstance()
  if (!instance) {
    throw new Error('useToast() debe ser usado dentro de setup()')
  }

  const toast = instance.proxy.$toast

  return {
    open: toast.open,
    success: (message) => toast.open({ message, type: 'success', duration: 4000, position: "top-right"}),
    error: (message) => toast.open({ message, type: 'error' }),
    warning: (message) => toast.open({ message, type: 'warning', duration: 4000, position: "top-right" }),
    info: (message) => toast.open({ message, type: 'info' }),
  }
}
